(function ($) {
  $(function () {
    const $drawer = $('#nav-mobile');
    const $overlay = $('.nav-mobile-overlay');
    const $toggle = $('.nav-mobile-toggle');

    function openDrawer() {
      $drawer.removeClass('-translate-x-full').attr('aria-hidden', 'false').removeAttr('inert');
      $overlay.removeClass('hidden');
      $toggle.attr('aria-expanded', 'true');
      // nav-drawer-open demotes the fixed widgets that sit above the overlay
      // (WhatsApp button); see app.scss.
      $('body').addClass('overflow-hidden nav-drawer-open');
    }

    function closeDrawer() {
      $drawer.addClass('-translate-x-full').attr('aria-hidden', 'true').attr('inert', '');
      $overlay.addClass('hidden');
      $toggle.attr('aria-expanded', 'false');
      $('body').removeClass('overflow-hidden nav-drawer-open');
    }

    $toggle.on('click', openDrawer);
    $('.nav-mobile-close').on('click', closeDrawer);
    $overlay.on('click', closeDrawer);

    // Drawer submenus collapse behind chevron toggles (flatsome accordion)
    const chevron =
      '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg>';

    $drawer.find('.nav-mobile__list > li.menu-item-has-children').each(function () {
      $(this)
        .children('a')
        .first()
        .after('<button type="button" class="sub-toggle" aria-expanded="false" aria-label="Submenu">' + chevron + '</button>');
    });

    $drawer.on('click', '.sub-toggle', function () {
      const $li = $(this).closest('li');
      const open = $li.toggleClass('is-open').hasClass('is-open');
      $(this).attr('aria-expanded', open ? 'true' : 'false');
    });

    // Shop archive: FILTER opens the sidebar off-canvas on mobile
    const $shopSidebar = $('#shop-sidebar');
    const $shopOverlay = $('.shop-sidebar-overlay');
    const $filterToggle = $('.shop-filter-toggle');

    function closeFilter() {
      $shopSidebar.removeClass('is-open');
      $shopOverlay.addClass('hidden');
      $filterToggle.attr('aria-expanded', 'false');
      $('body').removeClass('overflow-hidden');
    }

    $filterToggle.on('click', function () {
      $shopSidebar.addClass('is-open');
      $shopOverlay.removeClass('hidden');
      $filterToggle.attr('aria-expanded', 'true');
      $('body').addClass('overflow-hidden');
    });

    $('.shop-sidebar-close').on('click', closeFilter);
    $shopOverlay.on('click', closeFilter);

    // Header style 3: search toggle reveals the search row under the bar
    const $searchToggle = $('.header-search-toggle');
    const $searchRow = $('.header-search-row');

    function closeSearchRow() {
      $searchRow.removeClass('is-open').addClass('hidden');
      $searchToggle.attr('aria-expanded', 'false');
    }

    $searchToggle.on('click', function () {
      const open = !$searchRow.hasClass('is-open');

      if (open) {
        $searchRow.removeClass('hidden').addClass('is-open');
        $searchToggle.attr('aria-expanded', 'true');
        $searchRow.find('input[type="search"]').first().trigger('focus');
      } else {
        closeSearchRow();
      }
    });

    $(document).on('keyup', function (e) {
      if (e.key === 'Escape' && $searchRow.hasClass('is-open')) {
        closeSearchRow();
      }
    });

    // Sticky header shadow
    const $header = $('#masthead');
    const $backToTop = $('.back-to-top');

    $(window).on('scroll', function () {
      const scrolled = $(window).scrollTop() > 10;
      $header.toggleClass('is-stuck', scrolled);

      if ($(window).scrollTop() > 400) {
        $backToTop.removeClass('hidden').addClass('flex');
      } else {
        $backToTop.addClass('hidden').removeClass('flex');
      }
    });

    $backToTop.on('click', function (e) {
      e.preventDefault();
      $('html, body').animate({ scrollTop: 0 }, 500);
    });
  });
})(jQuery);
